import PMALineBullet from "../components/PMALineBullet";
import PMAPageFooter from "../components/PMAPageFooter";
// import Test1ImgUpload from "../components/Test1ImgUpload";
import bnC from "../resources/PMA Business Network Connect.png";

//Image list related imports

import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
// import { useEffect } from "react";
import { Box } from "@mui/system";
import { Divider, Typography } from "@mui/material";

export default function DigitalPMAPg() {

    const secTitle = "";
    return (
        <div>

            <br />
            <PMALineBullet secTitle={secTitle + 'Digital @ PMA'} />

            <Box sx={{
                mt: 3,
                ml: 2,
                mb: 3
            }}>
                <b>We endeavour to provide Digital platforms which will benefit the PMA MSME community on
                    various Digital journeys.</b>
            </Box>
            {/* <br /> */}

            <ul>
                <li>
                    <Box sx={{
                        mt: 0,
                        ml: 2,
                        mb: 1
                    }}><b>Access the <a href="https://rbn.omnevu.com" rel="noopener noreferrer">
                        Business Network Connect App</a> here.* </b></Box>
                </li>
            </ul>
            <Box
                component="img"
                sx={{
                    height: 380,
                    width: '50%',
                    // maxHeight: { xs: 1233, md: 167 },
                    // maxWidth: { xs: 1350, md: 250 },
                    objectFit: 'cover',
                    mt: 2,
                    ml: 3,
                    mb: 3,
                    border: 1,
                    p: 1,
                }}
                alt="Business Network Connect"
                src={bnC}
            />


            <br />


            <ul>
                <li>
                    <Box sx={{
                        mt: 0,
                        ml: 2,
                        mb: 10

                    }}><b>Access the <a href="https://www.work2life.com" rel="noopener noreferrer">
                        Jobs/Inernships, Counselling, Coaching and CSR Marketplaces</a> here.* </b></Box>
                </li>
            </ul>


            <Typography variant="caption" color="text.secondary" display="block"
                sx={{ m: 2 }}>
                * - You'll be redirected to External Links/URLs.
            </Typography>

            <PMAPageFooter />
        </div>
    );
}
